'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useId, } from 'react';
export const OverlayContext = createContext({
    headingId: '',
});
export const OverlayProvider = (props) => {
    const uid = useId();
    const { children, headingId = `${uid}-overlay-title`, onClose, } = props;
    return (_jsx(OverlayContext.Provider, { value: {
            headingId,
            onClose,
        }, children: children }));
};
export const useOverlayContext = () => {
    const context = useContext(OverlayContext);
    if (!context) {
        console.warn('useOverlayContext: Missing OverlayContext. Please wrap your component in an OverlayProvider.');
    }
    return context;
};
